import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import MerchantBadge from 'domains/merchant/atoms/merchant-badge'
import { MERCHANT_TYPE } from 'domains/merchant/constants'
import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  buttonText       : PropTypes.string,
  buttonColour     : PropTypes.string,
  isButtonDisabled : PropTypes.func,
  onButtonClick    : PropTypes.func
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

/**
 * Columns definition for Merchant Table
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const merchantTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick
}) => {

  const MerchantTypeFilter = ({ column }) => {
    const options = Object.keys(MERCHANT_TYPE).map((key) => (
      {
        label : MERCHANT_TYPE[key],
        value : MERCHANT_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const MerchantTypeCell = (row) => <MerchantBadge merchant_type={ row.cell.value } />

  const ActionCell = ({ cell: { row } }) => {

    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        disabled={ disabled }
        text={ buttonText }
      />
    )
  }

  MerchantTypeFilter.propTypes = filterPropTypes
  ActionCell.propTypes         = actionCellPropTypes

  return (
    [
      {
        Header   : 'Code',
        accessor : 'code'
      },
      {
        Header   : 'Name',
        accessor : 'name'
      },
      {
        Header   : 'Username',
        accessor : 'username'
      },
      {
        Header   : <>Merchant <br/> Type</>,
        accessor : 'merchant_type',
        id       : 'merchant_type',
        Filter   : MerchantTypeFilter,
        Cell     : MerchantTypeCell
      },
      {
        Header   : 'Phone',
        accessor : 'phone_number'
      },
      {
        Header   : 'Email',
        accessor : 'email'
      },

      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

merchantTableColumns.propTypes = propTypes

export default merchantTableColumns
